/**
 * @desc 获取IOT生产监控URL
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** baseCode */
  baseCode?: string;
  /** baseId */
  baseId?: string;
  /** factoryCode */
  factoryCode?: string;
  /** systemCode */
  systemCode?: string;
}

export function request(
  params: Params,
): Promise<defs.StandardReturn<defs.MonitorURLResponse>> {
  return defHttp.get({
    url: '/web/IOT/listMonitorURLs',

    params,
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<defs.MonitorURLResponse>> {
  return defHttp.get({
    url: '/mock/web/IOT/listMonitorURLs',

    params,
  });
}
